// frontend/src/App.js
import React, { useEffect } from 'react';
import { socket } from './socket';
import ErrorBoundary from './components/ErrorBoundary';
import { AppProvider } from './contexts/AppContext';
import AppContent from './components/AppContent';
import { usePerformanceMonitoring } from './hooks/usePerformanceMonitoring';

// Оптимизированный порядок импортов стилей
import './styles/variables.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/chat.css';
import './styles/queue.css';
import './styles/animations.css';
import './styles/responsive.css';
import './styles/mobile-navigation.css';
import './styles/Room.css';
import './styles/mobile-theme.css';
import './styles/mobile-animations.css';
import './styles/ConfirmModal.css';
import './styles/ErrorBoundary.css';
import './styles/CookieConsentBanner.css';


function App() {
    // Мониторинг производительности
    usePerformanceMonitoring('App');

    // Подключение к сокету
    useEffect(() => {
        socket.connect();

        return () => {
            // Cleanup сокета обрабатывается в AppContent через useOptimizedSocket
        };
    }, []);

    return (
        <ErrorBoundary>
            <AppProvider>
                <AppContent />
            </AppProvider>
        </ErrorBoundary>
    );
}

export default App;
